import { IError } from '@checkout/errors';
import { ILanguageChangeSuccessPayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic, ofType } from 'redux-observable';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { catchError, flatMap, mergeMap } from 'rxjs/operators';
import { LanguageChangeRequestAction, RootAction } from '../actions/actionTypes.d';
import ActionTypes from './../actions/actionTypes';
import { languageChangeSuccess, languageFallback } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';
import { logger } from './../utils/logger';

export const changeLanguageEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$.pipe(
    ofType(ActionTypes.LOCALE_TRANSLATIONS_FETCH_REQUEST),
    mergeMap((action: LanguageChangeRequestAction) => {
      return fromPromise$(rest.httpPut(`/languages/${action.payload.language}`))
        .pipe(
          flatMap((response: AxiosResponse<ILanguageChangeSuccessPayload>) => {
            return of$(languageChangeSuccess(response.data));
          }),
          catchError((error: IError) => {
            logger(error);
            return of$(languageFallback(action.payload.language));
          })
        );
    })
  );
